import {
  EventCoveredEnum,
  type DisruptionProtectionAncillaryContract,
  type MissedConnection,
} from "@b2bportal/air-booking-api";
import type { DisruptionState } from "../../../store";
import {
  DisruptionContractStatus,
  type DisruptionExerciseState,
} from "./slice";

export const getDisruptionExerciseProgress = (state: DisruptionState) => {
  return state.disruption.disruptionExerciseState.disruptionExerciseProgress;
};

export const getDisruptionExerciseToken = (state: DisruptionExerciseState) =>
  state.token;

export const getHasCheckedBags = (state: DisruptionState) =>
  state.disruption.disruptionExerciseState.hasCheckedBags;

export const disruptionExerciseFlags = (
  contract?: DisruptionProtectionAncillaryContract
) => {
  const status = contract?.status?.DisruptionContractStatus;

  return {
    isDisruptionProtectionExercisable:
      status === DisruptionContractStatus.ANY_EXERCISE_ELIGIBLE,
    isEligibleToBookReturn:
      status === DisruptionContractStatus.REBOOK_ONLY_ELIGIBLE,
  };
};

export const missedConnectionExerciseFlags = (
  contract?: DisruptionProtectionAncillaryContract | MissedConnection
) =>
  contract != null &&
  contract.status.DisruptionContractStatus ===
    DisruptionContractStatus.ANY_EXERCISE_ELIGIBLE;

export const isMissedConnectionContract = (
  contract?: DisruptionProtectionAncillaryContract
) =>
  contract != null &&
  contract.policyDetails?.eventsCovered.some(
    (event) => event.EventCovered === EventCoveredEnum.MissedConnections
  );
